export default "__VITE_ASSET__CuyaiSxb__"